import { cloneDeep } from 'lodash';
import { createStore } from 'vuex';

import Plugin from './plugin';
import storeObj from './store';

import './styles/main.scss';

export * from './embedding';

const store = () => createStore(cloneDeep(storeObj));

export { Plugin, store, storeObj };
